import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmBackendRecoveryBannerComponent} from './sm-backend-recovery-banner.component';
import {SmConfirmationDialogModule} from '../sm-confirmation-dialog/sm-confirmation-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SmConfirmationDialogModule,
  ],
  declarations: [SmBackendRecoveryBannerComponent],
  exports: [SmBackendRecoveryBannerComponent],
})
export class SmBackendRecoveryBannerModule {}
